import React from 'react';
import PropTypes from 'prop-types';
import ReactCountdown from 'react-countdown';
import { CountdownRenderer } from './CountdownRenderer';

export const Countdown = ({ countdownMS, renderer, ...props }) => {
  return (
    <ReactCountdown
      {...props}
      date={Date.now() + countdownMS}
      renderer={renderer}
    />
  );
};

Countdown.propTypes = {
  countdownMS: PropTypes.number,
  renderer: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
};

Countdown.defaultProps = {
  countdownMS: 600000,
  renderer: CountdownRenderer,
};
